import { defineAsyncComponent } from 'vue';

// TODO: DGC-27954 works, but need to expose for Compiler. Pass as a constructor prop?
//  Also needs to define every component available.
export const asyncComponents = {
  RegistrationPage: defineAsyncComponent(() => import('@/modules/register/RegistrationPage/RegistrationPage.vue')),
  ConfigurableTextPage: defineAsyncComponent(() => import('@/modules/register/ConfigurableTextPage/ConfigurableTextPage.vue')),
  AccessTextField: defineAsyncComponent(() => import('@/components/AccessTextField/AccessTextField.vue')),
  AccessAlternativeIDWithOptions: defineAsyncComponent(() => import('@/components/AccessAlternativeIDWithOptions/AccessAlternativeIDWithOptions.vue')),
  FormAccessSelect: defineAsyncComponent(() => import('@/components/FormAccessSelect/FormAccessSelect.vue')),
  AccessDateInput: defineAsyncComponent(() => import('@/components/AccessDateInput/AccessDateInput.vue')),
  IgcPhoneField: defineAsyncComponent(() => import('@/components/IgcPhoneField/IgcPhoneField.vue')),
  AccessForm: defineAsyncComponent(() => import('@/modules/personal-details/components/AccessForm.vue')),
  TutorialPage: defineAsyncComponent(() => import('@/components/TutorialPage/TutorialPage.vue')),

  // documents
  IgcFilePage: defineAsyncComponent(() => import('@/components/IgcFilePage/IgcFilePage.vue')),

  StaticPage: defineAsyncComponent(() => import('@/components/StaticPage/StaticPage.vue')),
  WaitPage: defineAsyncComponent(() => import('@/components/WaitPage/WaitPage.vue')),
  VideoPage: defineAsyncComponent(() => import('@/modules/consent/modules/VideoPage/VideoPage.vue')),
  QuizPage: defineAsyncComponent(() => import('@/modules/consent/modules/QuizPage/QuizPage.vue')),
  SignaturePage: defineAsyncComponent(() => import('@/modules/consent/modules/SignaturePage/SignaturePage.vue')),
  ThankYouPage: defineAsyncComponent(() => import('@/components/ThankYouPage/ThankYouPage.vue')),
  IgcSelectableSectionPage: defineAsyncComponent(() => import('@/components/IgcSelectableSectionPage/IgcSelectableSectionPage.vue')),
  ChoiceQuestionPage: defineAsyncComponent(() => import('@/components/choiceQuestionPage/choiceQuestionPage.vue')),
  AccessSubmissionPage: defineAsyncComponent(() => import('@/components/AccessSubmissionPage/AccessSubmissionPage.vue')),

  // questionnaire
  QuestionnaireGeneric: defineAsyncComponent(() => import('@/modules/questionnaire/components/QuestionnaireGeneric.vue')),
  IgcMultiCheckboxField: defineAsyncComponent(() => import('@/components/IgcMultiCheckboxField/IgcMultiCheckboxField.vue')),
  IgcAccessDateInputField: defineAsyncComponent(() => import('@/components/IgcAccessDateInputField/IgcAccessDateInputField.vue')),
  IgcFreetextField: defineAsyncComponent(() => import('@/components/IgcFreetextField/IgcFreetextField.vue')),
  AccessAutocomplete: defineAsyncComponent(() => import('@/components/AccessAutocomplete/AccessAutocomplete.vue')),
  IgcRadioButtonsGroupSelection: defineAsyncComponent(() => import('@/components/IgcRadioButtonsGroupSelection/IgcRadioButtonsGroupSelection.vue')),
  NlSelect: defineAsyncComponent(() => import('@/modules/questionnaire/components/NlSelect.vue')),
  ExtendedSelect: defineAsyncComponent(() => import('@/modules/questionnaire/components/ExtendedSelect.vue')),

  // menu
  IgcHelp: defineAsyncComponent(() => import('@/components/IgcHelp/IgcHelp.vue')),
  IgcQuestionnaireOverview: defineAsyncComponent(() => import('@/components/IgcQuestionnaireOverview/IgcQuestionnaireOverview.vue')),
  IgcMenuFAQ: defineAsyncComponent(() => import('@/components/IgcMenuFAQ/IgcMenuFAQ.vue')),
  LearningCenter: defineAsyncComponent(() => import('@/modules/learning-center/components/LearningCenter.vue')),

  // results
  Results: defineAsyncComponent(() => import('@/modules/results/ResultsApp.vue')),
};
